jQuery(function($) {
  'use strict';

  var $modals = $('.js-modal'),
      $modalTriggers = $('.js-modal-trigger'),
      $focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
      $hashes,
      $modal,
      $modalId;

  var triggeredByKeyboard = false;
  // Move to body
  $('body').append($modals);
  
  // Detect if keyboard interaction is being used only on modal triggers
  $modalTriggers.on('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Tab') {
      triggeredByKeyboard = true;
    }
  });

  // Show modal and focus on it only if triggered by keyboard
  $modalTriggers.on('click', function(e) {
    var $trigger = $(this),
        $target = $trigger.data('modal'),
        $modal = $modals.filter('[data-modal="' + $target + '"]');

    window.helper.showModal($modal);

    // Focus on modal only if triggered by keyboard
    if (triggeredByKeyboard) {
      var $firstFocusable = $modal.find($focusableElementsString).first();
      setTimeout(function() {
        $firstFocusable.focus();
      }, 500);
    }
  });

  function initialize() {
    $modals.each(function() {
      $modal = $(this);

      window.helper.bindModal($modal);
      if ($modal.hasClass('js-modal--show-on-start')) {
        window.helper.showModal($modal, true);
      }
    });

    $hashes = function() {
      var hash = window.location.hash.replace('#', '');

      if (hash) {
        return hash.split('/');
      }

      return [];
    };

    if ($hashes.length > 1 && $hashes.indexOf('m') !== -1) {
      $modalId = $hashes[1];
      $modal = $modals.filter('[data-modal="' + $modalId + '"]');

      if ($modal.length > 0) {
        window.helper.showModal($modal, true);
      }
    }
  }

  if (window && window.helper && window.helper.showModal) {
    initialize();
  } else {
    $(window).on('core:finished', () => {
      initialize();
    });
  }
});
